class CurrencyService {
  private currencyDataCache: any[] | null = null;

  // Get all currencies from JSON (cached)
  async getAllCurrencies(): Promise<any[]> {
    if (this.currencyDataCache) {
      return this.currencyDataCache;
    }

    try {
      const response = await fetch("/data/country_code_currencies.json");
      if (!response.ok) {
        throw new Error("Failed to fetch currencies data");
      }
      const data = await response.json();
      this.currencyDataCache = data;
      return this.currencyDataCache || [];
    } catch (error) {
      console.error("Error fetching currencies:", error);
      return [];
    }
  }

  // Get currency code from country code
  async getCurrencyByCountry(countryCode: string): Promise<string | null> {
    const data = await this.getAllCurrencies();
    const country = data.find(
      (item: any) => item.country_code?.toUpperCase() === countryCode?.toUpperCase()
    );
    return country?.currency_code || null;
  }

  // Get all unique currencies
  async getUniqueCurrencies(): Promise<string[]> {
    const data = await this.getAllCurrencies();
    const currencies = new Set<string>();
    data.forEach((item: any) => {
      if (item.currency_code) {
        currencies.add(item.currency_code);
      }
    });
    return Array.from(currencies).sort();
  }

  // Get countries for a specific currency
  async getCountriesByCurrency(currencyCode: string): Promise<any[]> {
    const data = await this.getAllCurrencies();
    return data.filter(
      (item: any) => item.currency_code?.toUpperCase() === currencyCode?.toUpperCase()
    );
  }
}

export default new CurrencyService();
